<template>
  <div>
    <DropDownSelect
      v-validate="'hasDevicePostureCondition'"
      data-test-id="dropDownSelect"
      label="Status"
      :name="name"
      :options="options"
      :value="model.status"
      @input="(newValue) => setAttribute('status', newValue)"
    />
  </div>
</template>

<script>
import { ExpressionStatus } from 'client/Security/data/Condition';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { find } from 'lodash';
import { mapGetters } from 'vuex';
import ConditionDevice from 'client/Security/data/ConditionDevice';
import ConditionDeviceEncrypted from 'client/Security/data/ConditionDeviceEncrypted';
import DropDownSelect from 'client/components/DropDownMenu/DropDownSelect.vue';

const authNPolicyModel = StoreModelMap[ItemTypeConsts.authNPolicies];

export default {
  name: 'ConditionRowDevice',

  inject: ['$validator'],

  components: {
    DropDownSelect,
  },

  props: {
    inclusion: {
      type: String,
      default: 'all',
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: ConditionDevice,
      default: () => new ConditionDevice(),
    },
  },

  data() {
    return {
      model: null,

      options: [
        { name: 'JumpCloud managed device', value: ExpressionStatus.include },
        { name: 'Unmanaged device', value: ExpressionStatus.exclude },
      ],
    };
  },

  computed: {
    ...mapGetters(authNPolicyModel, [
      'item',
    ]),
  },

  watch: {
    inclusion: {
      // when value of inclusion changes, reset validator to keep all validation accurate
      handler() {
        this.$validator.reset();
      },
    },
  },

  beforeMount() {
    this.model = this.value;

    this.$emit('input', this.model);

    this.$validator.extend('hasDevicePostureCondition', {
      getMessage: 'Unmanaged devices are not compatible with device posture conditions.',
      validate: this.validateDevicePosture,
    });
  },

  methods: {
    setAttribute(key, value) {
      // reset validator when user changes value
      this.$validator.reset();

      this.model[key] = value;

      this.$emit('input', this.model);
    },

    validateDevicePosture() {
      const deviceEncrypted = find(this.item.conditions.expressions,
        (item => item instanceof ConditionDeviceEncrypted));

      // throw validation when device is 'unmanaged'
      // and disk encryption selected and inlusion is 'all'
      return !(this.model.status === ExpressionStatus.exclude && deviceEncrypted && this.inclusion === 'all');
    },
  },
};
</script>
